module.exports = __webpack_public_path__ + "static/img/1.6ee82a5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/5/1.png
// module id = hVLD
// module chunks = 0